// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/pharmacy-widget/pharmacy-widget.less
// module id = 3369
// module chunks = 0